export default {
  init() {
    jQuery(window).scroll(function () {
      if (jQuery(this).scrollTop()  <= 0 ){
        jQuery('header').removeClass('scrolled');
      } else {
        jQuery('header').addClass('scrolled');
      }
  });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js